export default "__VITE_ASSET__Cv5pcOm7__"